import type { MarketResponseDto } from "Infrastructure/Api/Api";
import { MarketGeneralTab } from "Market/Components/Tabs/GeneralTab";
import { MarketOrderImportTab } from "Market/Components/Tabs/OrderImportTab";
import { MarketRegionsTab } from "Market/Components/Tabs/RegionsTab";
import { MarketPaths } from "Market/Routes/Routing";
import type { TabType } from "Shared/Components/Tabs/Types/TabType";

export enum MarketEditTabs {
	general = "general",
	regions = "regions",
	emails = "emails",
	import = "import",
}

export const getMarketEditTabs = (urlPath: string): TabType[] => [
	{
		index: MarketEditTabs.general,
		label: "General",
		path: MarketPaths.EditGeneral.path(urlPath),
		tab: (market: MarketResponseDto) => <MarketGeneralTab market={market} />,
	},
	{
		index: MarketEditTabs.regions,
		label: "Regions",
		path: MarketPaths.EditRegions.path(urlPath),
		tab: (market: MarketResponseDto) => (
			<MarketRegionsTab urlPath={urlPath} market={market} />
		),
	},
	{
		index: MarketEditTabs.import,
		label: "Imports",
		path: MarketPaths.OrderImport.path(urlPath),
		tab: (market: MarketResponseDto) => (
			<MarketOrderImportTab market={market} />
		),
	},
];
